module.exports = __webpack_public_path__ + "static/img/scare1.e55bdf73.png";